<template>
  <div class="contact-view">
    <table class="table table-sm table-fixed table-bordered">
      <tbody>
        <tr class="thead-light">
          <th colspan="2">General</th>
        </tr>
        <tr>
          <td>Company name</td>
          <td>{{subscriberData.CompanyName}}</td>
        </tr>
        <tr>
          <td>Company phone number</td>
          <td>{{subscriberData.CompanyPhone}}</td>
        </tr>
        <tr>
          <td>Company email address</td>
          <td>{{subscriberData.CompanyEmail}}</td>
        </tr>
        <tr class="thead-light">
          <th colspan="2">Address</th>
        </tr>
        <tr>
          <td>Street &amp; number / PO box number</td>
          <td>{{subscriberData.CompanyAddress}}</td>
        </tr>
        <tr>
          <td>ZIP code</td>
          <td>{{subscriberData.CompanyZip}}</td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{subscriberData.CompanyCountry}}</td>
        </tr>
        <tr class="thead-light">
          <th colspan="2">Postal Address</th>
        </tr>
        <tr>
          <td>Street &amp; number / PO box number</td>
          <td>{{subscriberData.PostalAddress}}</td>
        </tr>
        <tr>
          <td>ZIP code</td>
          <td>{{subscriberData.PostalZip}}</td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{subscriberData.PostalCountry}}</td>
        </tr>
        <tr class="thead-light">
          <th colspan="2">Invoice Address</th>
        </tr>
        <tr>
          <td>Street &amp; number / PO box number</td>
          <td>{{subscriberData.InvoiceAddress}}</td>
        </tr>
        <tr>
          <td>ZIP code</td>
          <td>{{subscriberData.InvoiceZip}}</td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{subscriberData.InvoiceCountry}}</td>
        </tr>
        <tr class="thead-light">
          <th colspan="2">Main contact person</th>
        </tr>
        <tr>
          <td>Name</td>
          <td>{{subscriberData.EmployeeFirstname1}} {{subscriberData.EmployeeLastname1}}</td>
        </tr>
        <tr>
          <td>Function</td>
          <td>{{subscriberData.EmployeeFunction1}}</td>
        </tr>
        <tr>
          <td>Email address</td>
          <td>{{subscriberData.EmployeeEmail1}}</td>
        </tr>
        <tr>
          <td>Phone number</td>
          <td>{{subscriberData.EmployeePhone1}}</td>
        </tr>
        <tr class="thead-light">
          <th colspan="2">Secondary contact person</th>
        </tr>
        <tr>
          <td>Name</td>
          <td>{{subscriberData.EmployeeFirstname2}} {{subscriberData.EmployeeLastname2}}</td>
        </tr>
        <tr>
          <td>Function</td>
          <td>{{subscriberData.EmployeeFunction2}}</td>
        </tr>
        <tr>
          <td>Email address</td>
          <td>{{subscriberData.EmployeeEmail2}}</td>
        </tr>
        <tr>
          <td>Phone number</td>
          <td>{{subscriberData.EmployeePhone2}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ContactView",
  computed: {
    subscriberData() {
      return this.$store.state.subscriberData;
    }
  }
};
</script>